module.exports = "<collection> <collection-item avatar> <img :src=imageUrl alt=\"\" class=circle> <span class=title>Title</span> <p>First Line <br> Second Line </p> <a href=#! class=secondary-content><icon value=grade></icon></a> </collection-item> <collection-item avatar> <icon value=folder class=circle></icon> <span class=title>Title</span> <p>First Line <br> Second Line </p> <a href=#! class=secondary-content><icon value=grade></icon></a> </collection-item> </collection>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/collections/avatar-collection.vue
 ** module id = 237
 ** module chunks = 0
 **/